import { Exclude, Expose, Transform, TransformFnParams } from 'class-transformer';
// import { ControlInterface } from '@modules/pdf/pdf-editor/controls/control.type';
import { BaseModel } from '@core/data-access';
import { ContentBuilderFieldType } from '../types/content-builder-field.type';
import { DynamicFormDateTime } from './dynamic-form-datetime.model';
import { DynamicFormDropDown } from './dynamic-form-dropdown.model';
import { DynamicFormFile } from './dynamic-form-file.model';
import { DynamicFormControlLayout, DynamicFormGroupLayout, DynamicFormLayout } from './dynamic-form-layout.model';
import { DynamicFormNumber } from './dynamic-form-number.model';
import { DynamicFormTextBox } from './dynamic-form-textbox.model';
import { FormFieldBase } from './form-field-base.model';
import { ParticipantDateField } from './participant-date-field.model';
import { ParticipantTextField } from './participant-text-field.model';
import { SignatureField } from './signature-field.model';
import { Default } from '@core/util';

export interface ContentBuilderFieldInterface {
  type?: string;
  data?: object;
  properties?: { [x: string]: FormFieldBase };
  placeholder?: object;
  layouts?: { [x in ContentBuilderFieldType]?: DynamicFormLayout[] };
  // controls?: ControlInterface[];
}

@Exclude()
export class ContentBuilderFieldModel extends BaseModel implements ContentBuilderFieldInterface {
  @Expose()
  @Default('jsonSchema')
  type!: string;

  @Expose()
  @Default({})
  @Transform((params: TransformFnParams) => {
    const data = params.value;
    if (typeof data === 'string' || Array.isArray(data)) {
      return {};
    }
    return data;
  })
  data!: object;

  @Expose()
  @Default({})
  @Transform((params: TransformFnParams) => {
    const data = params.value;
    const properties: any = {};
    if (data instanceof Object) {
      Object.keys(data).forEach(key => {
        if (data[key].fieldType === 'dynamicField') {
          switch (data[key].controlType) {
            case 'textbox':
              properties[key] = new DynamicFormTextBox(data[key]);
              break;
            case 'number':
              properties[key] = new DynamicFormNumber(data[key]);
              break;
            case 'dropdown':
              properties[key] = new DynamicFormDropDown(data[key]);
              break;
            case 'date':
              properties[key] = new DynamicFormDateTime(data[key]);
              break;
            case 'file':
              properties[key] = new DynamicFormFile(data[key]);
              break;
            default:
              properties[key] = data[key];
          }
        } else if (data[key].fieldType === 'signatureField') {
          properties[key] = new SignatureField(data[key]);
        } else if (data[key].fieldType === 'participantField') {
          switch (data[key].controlType) {
            case 'textbox':
              properties[key] = new ParticipantTextField(data[key]);
              break;
            case 'date':
              properties[key] = new ParticipantDateField(data[key]);
              break;
            default:
              properties[key] = data[key];
          }
        }
      });
    }

    return properties;
  })
  properties!: { [x: string]: FormFieldBase };

  @Expose()
  @Transform((params: TransformFnParams) => {
    const data = params.value;
    if (data && typeof data === 'object' && !Array.isArray(data)) {
      const layouts: any = {};
      Object.keys(data).forEach(key => {
        layouts[key] = data[key].map((layout: any) => {
          layout.type = layout.type || 'control';
          if (layout.type === 'control') {
            return new DynamicFormControlLayout(layout);
          } else {
            return new DynamicFormGroupLayout(layout);
          }
        });
      });
      return layouts;
    }

    return {
      dynamicField: [],
      signatureField: [],
      dealTable: [],
      participantField: [],
    };
  })
  layouts!: { [x in ContentBuilderFieldType]?: DynamicFormLayout[] };

  @Expose()
  placeholder!: object;

  // @Expose()
  // @Default([])
  // controls?: ControlInterface[];
}
